module.exports = __webpack_public_path__ + "img/guides-bg.d3b270e.png";